<template>
  <div :class="_class" :data-label-type="levelType">
    {{ value }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatPill",
  props: {
    id: {
      type: [String, Number],
      description: "Not in use"
    },
    value: {
      type: [String, Number]
    },
    level: {
      type: [String, Number],
      default: ""
    },
    mild: {
      type: Boolean,
      default: false,
      description:
        "Sets css class for the visual style of the tag to have soft colour with a solid border."
    },
    sharp: {
      type: Boolean,
      default: false,
      description:
        "Sets css class for  the tag to have a solid colour and 90º corners."
    },
    small: {
      type: Boolean,
      default: false,
      description: "Sets css class for tag to render at a smaller size."
    },
    light: {
      type: Boolean,
      default: false,
      description: "Sets css class for  style of the tag to have soft colour."
    },
    inlinefirst: {
      type: Boolean,
      default: false,
      description:
        "Needs to be used in conjunction with inlinesecond to ensure the spacing is correct"
    },
    inlinesecond: {
      type: Boolean,
      default: false,
      description:
        "Positions the pill so it appears attached to the previous. Must be used in conjunction with inlinefirst"
    }
  },
  computed: {
    _class: function () {
      return {
        "cat-pill": true,
        mild: this.mild,
        sharp: this.sharp,
        small: this.small,
        light: this.light,
        "pill-inline-first": this.inlinefirst,
        "pill-inline-second": this.inlinesecond,
        zero: parseInt(this.value) === 0,
        [this.level]: this.level
      };
    },
    levelType: function () {
      let level = this.level || "default";
      return "badge-" + level;
    }
  }
});
</script>
